import { StringParam, useQueryParams, withDefault } from "use-query-params";
import { InputSelect, SelectOption } from "../../components/InputSelect";
import { Button } from "../../components/Button";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import React, { useEffect } from "react";
import cn from "classnames";
import { useTranslation } from "../../hooks/useTranslation";
import { AlbumType } from "./Albums";
import { ContentTypeOptions } from "./AlbumsFilters";

type Props = {
  className?: string;
  onApply: (params: DraftFiltersParams) => Promise<any>;
};

export type DraftFiltersParams = {
  type?: DraftSearchType;
  content_type?: AlbumType;
  limit?: number;
  offset?: number;
};

export enum DraftSearchType {
  EDIT = "EDIT",
  PUBLISH = "PUBLISH",
}

function SearchTypeOptions(t: any): SelectOption[] {
  return [
    {
      label: `${t("editable")}`,
      value: DraftSearchType.EDIT,
    },
    {
      label: `${t("publishing")}`,
      value: DraftSearchType.PUBLISH,
    },
  ];
}

export const DraftsFilters: React.FC<Props> = ({ className, onApply }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useQueryParams({
    type: withDefault(StringParam, DraftSearchType.EDIT),
    content_type: withDefault(StringParam, AlbumType.AUDIO),
  });

  useEffect(() => {
    onApply(query as DraftFiltersParams).then();
  }, []);

  useEffect(() => {
    document.onkeyup = function (e) {
      if (e.key === "Enter") {
        void onApply(query as DraftFiltersParams);
      }
    };

    return () => {
      document.onkeyup = null;
    };
  }, [query]);

  return (
    <div className={className}>
      <div className={cn("flex gap-2 mb-2")}>
        <InputSelect
          value={query.type}
          options={SearchTypeOptions(t)}
          onChange={(v) => {
            setQuery({ type: v.value as DraftSearchType });
            void onApply({
              ...query,
              type: v.value as DraftSearchType,
            } as DraftFiltersParams);
          }}
        />

        <InputSelect
          value={query.content_type}
          options={ContentTypeOptions(t)}
          onChange={(v) => {
            setQuery({ content_type: v.value as any });
            void onApply({
              ...query,
              content_type: v.value as any,
            } as DraftFiltersParams);
          }}
        />

        <Button
          icon={faSearch}
          label={`${t("search")}`}
          onClick={() => onApply(query as DraftFiltersParams)}
        />
      </div>
    </div>
  );
};
